import React, { useState, useContext } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import packageJson from "../../package.json";
import { CartContext } from "../context/CartContext";

const BASE_URL = packageJson.apiUrl;

const CheckoutForm = ({ totalPrice }) => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const { clearCart, cart } = useContext(CartContext);

  const [paymentStatus, setPaymentStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [cardComplete, setCardComplete] = useState(false); // 👈 New state

  const user = JSON.parse(localStorage.getItem("user"));

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      setPaymentStatus("Stripe has not loaded yet.");
      return;
    }

    if (!cardComplete) {
      setPaymentStatus("Please enter complete card details.");
      return; // ⛔️ Stop here
    }

    const cardElement = elements.getElement(CardElement);

    setLoading(true);
    setPaymentStatus("");
const couponCode  = localStorage.getItem("appliedCoupon") || "";
const discount = parseFloat(localStorage.getItem("couponDiscount") || 0);
const finalPrice = parseFloat(localStorage.getItem("finalPrice") || totalPrice);

    try {
      // Step 1: Call your Laravel backend to create a payment intent
      const { data } = await axios.post(`${BASE_URL}/create-payment-intent`, {
        amount: finalPrice * 100,
        currency: "gbp",
        uid: user.id,
        name: user.name,
        email: user.email,
        phone: user.phone,
        address: user.address,
        cart: cart,
	    discount:discount,
        coupon_code:couponCode ,
      });

      if (!data.clientSecret) {
        throw new Error("Failed to receive client secret.");
      }

      // Step 2: Confirm the card payment
      const { paymentIntent, error } = await stripe.confirmCardPayment(data.clientSecret, {
        payment_method: {
          card: cardElement,
          billing_details: {
            name: user.name,
          },
        },
      });

      // Step 3: Handle result
      if (error) {
        setPaymentStatus(`Payment failed: ${error.message}`);
      } else if (paymentIntent?.status === "succeeded") {
		   await axios.post(`${BASE_URL}/payment-success`, {
				amount: finalPrice * 100,
				uid: user.id,
				name: user.name,
				email: user.email,
				phone: user.phone,
				address: user.address,
				cart: cart,
				discount:discount,
                coupon_code:couponCode ,
			  });
        setPaymentStatus("Payment successful!");
		  localStorage.removeItem("appliedCoupon");
		  localStorage.removeItem("couponDiscount");
		  localStorage.removeItem("finalPrice");
        clearCart();
        navigate("/success");
      } else {
        setPaymentStatus("Payment was not completed.");
        navigate("/failed");
      }
    } catch (error) {
      setPaymentStatus(`Error: ${error.message}`);
      navigate("/failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <CardElement
        options={{
          style: {
            base: {
              fontSize: "16px",
              color: "#424770",
              "::placeholder": { color: "#aab7c4" },
            },
            invalid: {
              color: "#9e2146",
            },
          },
        }}
        onChange={(event) => setCardComplete(event.complete)} // ✅ Watch if card is fully filled
      />
      <button type="submit" disabled={!stripe || loading}>
        {loading ? "Processing..." : `Pay £${totalPrice.toFixed(2)}`}
      </button>
      {paymentStatus && <p>{paymentStatus}</p>}
    </form>
  );
};

export default CheckoutForm;
